module.exports = "/_next/static/images/28c2f1540928e0e03ccb494da0b1367b-xpeer-xs.jpg.webp";